import { NUMBER_ARRAY } from "common/global/constants";
import { RedTheme } from "common/global";

const redtheme = RedTheme;

export const asterikStyles = {
    fontSize: '14px',
    lineHeight: '12px',
    fontWeight: NUMBER_ARRAY.fiveHundred,
    fontFamily: 'Johnson Text',
    color: redtheme.palette.primary.main,
};